module.exports = __webpack_public_path__ + "img/logoPreparadasParaBatalha.2e72f54b.png";